import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  right: 40px;
  bottom: 20px;
`